import { render, staticRenderFns } from "./AddErrorReport.vue?vue&type=template&id=8fc023a2&"
import script from "./AddErrorReport.vue?vue&type=script&lang=js&"
export * from "./AddErrorReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports